import React from "react";

function SingleListing({ listing }) {
  const labelBg =
    listing.tipologia_contratto == "vendita" ? "#BB005F" : "#88a650";

  return (
    <div id={`card-${listing.id}`}>
      <div
        className="uk-card uk-card-default listing-cards"
        data-id={listing.id}
      >
        <div className="uk-card-media-top">
          <a href={listing.permalink}>
            <img
              src={listing.image}
              alt={listing.title}
              style={{ height: "200px", width: "100%", objectFit: "cover" }}
            />
          </a>
          <div className="uk-position-top-right">
            <h5
              className="listing-tipologia uk-label"
              style={{ backgroundColor: labelBg }}
            >
              {listing.tipologia_contratto}
            </h5>
          </div>
        </div>

        <div className="uk-card-body uk-padding-small">
          <div className="card-body-header">
            <div className="uk-margin">
              <h4>
                <span style={{ color: "#BB005F" }}>
                  {listing.prezzo > 0 ? listing.prezzo + "€" : "su richiesta"}
                </span>
              </h4>
            </div>
            <div className="uk-margin uk-margin-remove-bottom uk-flex uk-flex-left uk-text-center">
              {listing.camere && (
                <div className="icons-header">
                  <i className="fas fa-bed uk-margin-small-right"></i>
                  <br />
                  <span className="uk-text-small">{listing.camere}</span>
                </div>
              )}
              {listing.bagni && (
                <div className="icons-header">
                  <i className="fas fa-bath uk-margin-small-right"></i>
                  <br />
                  <span className="uk-text-small">{listing.bagni}</span>
                </div>
              )}
              {listing.sq_ft && (
                <div className="icons-header">
                  <i className="fas fa-house-user uk-margin-small-right"></i>
                  <br />
                  <span className="uk-text-small">{listing.sq_ft}</span>
                </div>
              )}
            </div>
          </div>
          <div className="card-inner-info">
            <div>
              <h2 className="uk-h5">{listing.title}</h2>
              <p className="uk-meta uk-margin-remove-top">
                <i className="fas fa-map-marker-alt uk-margin-small-right"></i>
                <span className="uk-text-small">{listing.indirizzo}</span>
              </p>
            </div>
          </div>
        </div>
        <div className="uk-card-footer uk-padding-small">
          <div className="uk-grid uk-child-width-1-2 uk-grid-collapse uk-text-center">
            <div className="uk-margin-small-bottom uk-first-column">
              <a
                href={listing.permalink}
                className="uk-button uk-button-primary uk-button-small"
              >
                Scopri
              </a>
            </div>
            <div>
              <button
                type="button"
                className="uk-button uk-button-primary uk-button-small quick-view"
                data-id={listing.id}
              >
                <i className="far fa-eye uk-margin-small-right"></i> Quick View
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default SingleListing;
